"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.NavCta = exports.MenuWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Button = _interopRequireDefault(require("../../Button"));

var MenuWrapper = (0, _styled.default)('div')(function (_ref) {
  var space = _ref.theme.space;
  return {
    margin: space.none,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    height: '100%'
  };
});
exports.MenuWrapper = MenuWrapper;
var NavCta = (0, _styled.default)(_Button.default)(function (_ref2) {
  var space = _ref2.theme.space;
  return {
    margin: "0 ".concat(space.xsmall)
  };
});
exports.NavCta = NavCta;
var _default = MenuWrapper;
exports.default = _default;